import store from '@/store';

export default class ChatUnpauseEvent {
  constructor(body) {
    const { status } = store.state.channel.channels.chat;
    const pauseName = body.body.reason;
    const channel = 'chat';

    if (status == 'scheduled_pause')
      return store.dispatch('pause/revertStatusLeaveSchedulePause', {
        channel,
        channelName: 'Chat',
        pauseName,
      });

    store.dispatch('pause/removePauseChat');
  }
}
